"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSpinnerColor;
function getSpinnerColor(_ref) {
  var scales = _ref.scales;

  return scales.neutral.N6A;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvY3JlYXRlLXRoZW1lL2Jhc2Uvc3Bpbm5lckNvbG9yLmpzIl0sIm5hbWVzIjpbImdldFNwaW5uZXJDb2xvciIsInNjYWxlcyIsIm5ldXRyYWwiLCJONkEiXSwibWFwcGluZ3MiOiI7Ozs7O2tCQUF3QkEsZTtBQUFULFNBQVNBLGVBQVQsT0FBcUM7QUFBQSxNQUFWQyxNQUFVLFFBQVZBLE1BQVU7O0FBQ2xELFNBQU9BLE9BQU9DLE9BQVAsQ0FBZUMsR0FBdEI7QUFDRCIsImZpbGUiOiJzcGlubmVyQ29sb3IuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBnZXRTcGlubmVyQ29sb3IoeyBzY2FsZXMgfSkge1xuICByZXR1cm4gc2NhbGVzLm5ldXRyYWwuTjZBXG59XG4iXX0=